import { ApiClient } from "./api-client";

export function getCompanies(queryParams) {
  return ApiClient.getInstance().get('/company', { params: queryParams }).catch((error) => {
    console.error('Error fetching user rooms:', error);
    throw error;
  });
}

export function getCompaniesPlain() {
  return ApiClient.getInstance().get('/company/plain').catch((error) => {
    console.error('Error fetching companies:', error);
    throw error;
  });
}

export function getCompany(companyId) {
  return ApiClient.getInstance().get('/company/:id', { urlParams: { id: companyId } }).catch((error) => {
    console.error('Error fetching company:', error);
    throw error;
  });
}

export function createCompany(name, maxUsers, description, defaultRoleId) {
  return ApiClient.getInstance().post('/company', { name: name, maxUsers: maxUsers, description: description, defaultRoleId: defaultRoleId }).catch((error) => {
    console.error('Error creating company:', error);
    throw error;
  });
}

export function getCompanyUsers(companyId) {
  return ApiClient.getInstance().get('/company/:id/users', { urlParams: { id: companyId } }).catch((error) => {
    console.error('Error fetching company data:', error);
  });
}

export function updateCompany(id, name, maxUsers, description, defaultRoleId) {
  return ApiClient.getInstance().put('/company', { id, name: name, maxUsers: maxUsers, description: description, defaultRoleId: defaultRoleId }).catch((error) => {
    console.error('Error updating company:', error);
    throw error;
  });
}

export function updateCompanyImage(compId, imageFile) {
  return ApiClient.getInstance().put(`/company/${compId}/image`, imageFile, { headers: { 'Content-Type': imageFile.type || 'image/png' }, }).catch((error) => {
    console.error('Error updating company image:', error);
    throw error;
  });
}

export function updateCompanyName(compId, name) {
  return ApiClient.getInstance().put('/company', { id: compId, name: name }).catch((error) => {
    console.error('Error fetching company data:', error);
    throw error;
  });
}

export function updateCompanyDesc(compId, desc) {
  return ApiClient.getInstance().put('/company', { id: compId, description: desc }).catch((error) => {
    console.error('Error fetching company data:', error);
    throw error;
  });
}

export function deleteCompany(id, deleteUsers = false) {
  return ApiClient.getInstance().delete('/company', { data: { companyId: id, deleteUsers: deleteUsers } }).catch((error) => {
    console.error('Error deleting company:', error);
    throw error;
  });
}
